'use client';

import { useTranslations } from 'next-intl';
import React, { useState } from 'react';
import { FiRefreshCw } from "react-icons/fi";
import NavBar from '@/components/header/NavBar';
import { useLocale } from 'next-intl';
import Dubble from '@/components/home-page/dubbleSection';
import { GlowingEffect } from '@/components/home-page/glowing-effect';
import { Box, Lock, Search, Settings, Sparkles } from "lucide-react";
import Why from '@/components/home-page/whySection';

import ContactForm from '@/components/home-page/ContactForm';
import FAQContainer from '@/components/home-page/FAQContainer';
import Footer from '@/components/footer/Footer';


const ContactForms: React.FC = () => {

  return (<>
  {/* Fixed background — stays behind everything while page scrolls */}
  <div
    className="bg-cover bg-center bg-no-repeat h-96 lg:h-[500px] relative"
    style={{ backgroundImage: `url('/hero/busi.avif')` }}
  >
   
<div className="absolute inset-0 bg-secondary/55 h-96 lg:h-[500px] " />
  <h1 className="absolute inset-0 flex items-center pt-20 lg:pt-40 justify-center text-white text-5xl lg:text-9xl font-extrabold text-center px-4 ">
   Business & Professional
  </h1>
    
  </div>
 

  <NavBar />
   <ul className="grid grid-cols-1 bg-secondary grid-rows-none gap-4 md:grid-cols-12 md:grid-rows-3 lg:gap-4 p-8 xl:grid-rows-2">
      <GridItem
        area="md:[grid-area:1/1/2/7] xl:[grid-area:1/1/2/5]"
        icon={<Box className="h-4 w-4 text-black dark:text-primary" />}
        title="Professional Services"
        description="From strategy and development to hosting and maintenance, we provide complete web solutions built to help your business grow and succeed online."
      />
 
      <GridItem
        area="md:[grid-area:1/7/2/13] xl:[grid-area:2/1/3/5]"
        icon={<Settings className="h-4 w-4 text-black dark:text-primary" />}
        title="Consulting"
        description="Get expert guidance to make the right technology decisions, improve your digital strategy, and turn your ideas into practical, scalable solutions."
      />
 
      <GridItem
        area="md:[grid-area:2/1/3/7] xl:[grid-area:1/5/3/8]"
        icon={<Lock className="h-4 w-4 text-black dark:text-primary" />}
        title="Legal, Finance & Fintech"
        description="We build secure, reliable digital solutions for legal, financial, and fintech businesses, helping streamline operations, protect sensitive data, and deliver seamless experiences for clients and users."
      />
 
      <GridItem
        area="md:[grid-area:2/7/3/13] xl:[grid-area:1/8/2/13]"
        icon={<Sparkles className="h-4 w-4 text-black dark:text-primary" />}
        title="Marketing & Advertising"
        description="We create high-performing digital solutions that help marketing and advertising businesses attract audiences, strengthen their brand, and turn online traffic into measurable growth."
      />
 
      <GridItem
        area="md:[grid-area:3/1/4/13] xl:[grid-area:2/8/3/13]"
        icon={<Search className="h-4 w-4 text-black dark:text-primary" />}
        title="Recruitment & HR"
        description="We build smart digital solutions that simplify recruitment, streamline HR processes, and create seamless experiences for employers, recruiters, and candidates."
      />
    </ul>
<Why/>
<ContactForm/>

<FAQContainer
  title={"Business &\nProfessional FAQs"}
  description="Answers to the most common questions clients ask about our solutions for business, professional services, and industry-specific needs."
  faq={[
    {
      question: "What industries do you build solutions for?",
      answer:
        "We work across legal, finance, fintech, marketing, recruitment, HR, and general professional services, tailoring each solution to the industry's needs.",
    },
    {
      question: "Can you help with both strategy and development?",
      answer:
        "Yes, we provide end-to-end support — from consulting and technology strategy through design, development, hosting, and maintenance.",
    },
    {
      question: "How do you handle sensitive business or client data?",
      answer:
        "We build with security best practices from the start, especially for legal, finance, and fintech clients handling sensitive information.",
    },
    {
      question: "Do you work with recruitment or HR platforms?",
      answer:
        "Yes, we build custom solutions that simplify recruitment workflows and HR processes for employers, recruiters, and candidates alike.",
    },
    {
      question: "Can you support a marketing or advertising business?",
      answer:
        "Absolutely. We build digital solutions designed to attract audiences, strengthen brand presence, and convert traffic into measurable results.",
    },
    {
      question: "Do you offer ongoing consulting after the project launches?",
      answer:
        "Yes, we offer continued consulting and technical guidance to help your business adapt and scale as your needs evolve.",
    },
  ]}
/>
<Footer/>
</>
  );
};

export default ContactForms;


interface GridItemProps {
  area: string;
  icon: React.ReactNode;
  title: string;
  description: React.ReactNode;
}
 
const GridItem = ({ area, icon, title, description }: GridItemProps) => {
  return (
    <li className={`min-h-[14rem] list-none  rounded-3xl ${area}`}>
      <div className="relative h-full rounded-2xl border p-2 md:rounded-3xl md:p-3">
     <GlowingEffect

  glow={true}
  disabled={false}
  spread={40}
  proximity={64}
  inactiveZone={0.01}
  borderWidth={2}
/>
        <div className="border-0.75 relative flex h-full flex-col justify-between gap-6 overflow-hidden rounded-xl p-6 md:p-6 ">
          <div className="relative flex flex-1 flex-col justify-between gap-3">
            <div className="w-fit rounded-lg border text-primary border-white p-2">
              {icon}
            </div>
            <div className="space-y-3">
              <h3 className="-tracking-4 mt-8 text-xl  font-bold text-balance text-black md:text-3xl dark:text-primary">
                {title}
              </h3>
              <h2 className="text-sm/[1.125rem] text-black md:text-xl dark:text-white  font-light">
                {description}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
};